module.exports = __webpack_public_path__ + "static/media/logo.eb78a67b.png";